/**
 * Lashé Gift With Purchase
 * ------------------------
 * Vienkārša loģika:
 *   1. Pārtveram VISUS fetch un XHR pieprasījumus uz cart endpoints
 *   2. Pēc katra cart pieprasījuma pārbaudām groza saturu
 *   3. Pievienojam vai noņemam dāvanu pēc vajadzības
 *
 * Debug: ?gwpdebug=1
 */

(function () {
  'use strict';

  const config = window.LasheGWP;
  if (!config) {
    console.error('[LasheGWP] Config nav atrasts');
    return;
  }

  const DEBUG = !!config.debug;
  const log = (...a) => DEBUG && console.log('%c[LasheGWP]', 'color:#b89968;font-weight:bold', ...a);
  const warn = (...a) => console.warn('[LasheGWP]', ...a);

  // Validation
  if (!config.triggerVariantId) {
    warn('triggerVariantId nav definēts — pārbaudi serum produkta handle');
    return;
  }
  if (!config.giftVariantId) {
    warn('giftVariantId nav definēts — pārbaudi gift produkta handle');
    return;
  }
  if (!config.giftAvailable) {
    warn('Dāvanas produkts nav pieejams (out of stock vai draft)');
    return;
  }
  if (!config.lipBalmVariantIds || !config.lipBalmVariantIds.length) {
    warn('Lūpu balzāmi kolekcija tukša vai handle nepareizs');
    return;
  }

  const TRIGGER_ID = Number(config.triggerVariantId);
  const GIFT_ID = Number(config.giftVariantId);
  const LIP_BALM_IDS = config.lipBalmVariantIds.map(Number);

  log('Aktīvs. Trigger:', TRIGGER_ID, '| Gift:', GIFT_ID, '| Lip balms:', LIP_BALM_IDS.length);

  let isProcessing = false;

  // ============ Cart helpers ============

  async function getCart() {
    const r = await fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    return r.json();
  }

  async function addGift() {
    log('→ Pievienojam dāvanu');
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: GIFT_ID,
          quantity: 1,
          properties: { _gift: 'true' }
        }]
      })
    });
    if (!r.ok) {
      warn('Add gift failed:', await r.text());
      return false;
    }
    log('✓ Dāvana pievienota');
    return true;
  }

  async function removeGift(lineKey) {
    log('→ Noņemam dāvanu');
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
    if (!r.ok) {
      warn('Remove gift failed:', await r.text());
      return false;
    }
    log('✓ Dāvana noņemta');
    return true;
  }

  // ============ Galvenā loģika ============

  async function reconcile(source) {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const cart = await getCart();

      const hasSerum = cart.items.some(i => i.variant_id === TRIGGER_ID && i.quantity > 0);
      const hasLipBalm = cart.items.some(i => LIP_BALM_IDS.includes(i.variant_id) && i.quantity > 0);

      // Meklējam tikai mūsu auto-pievienoto dāvanas līniju (ar `_gift=true` property).
      // Manuāli pievienotos atliecējus (bez šī property) NEAIZTIEKAM — klients var
      // nopirkt atliecēju kā parastu produktu par pilnu cenu.
      const giftLine = cart.items.find(i =>
        i.variant_id === GIFT_ID && i.properties && i.properties._gift === 'true'
      );

      log(`Check [${source}] — serums:${hasSerum} balzāms:${hasLipBalm} auto-dāvana:${!!giftLine}`);

      const shouldHaveGift = hasSerum && hasLipBalm;
      let changed = false;

      if (shouldHaveGift && !giftLine) {
        changed = await addGift();
      } else if (!shouldHaveGift && giftLine) {
        changed = await removeGift(giftLine.key);
      } else if (giftLine && giftLine.quantity > 1) {
        // Dāvanai jābūt tikai 1 — koriģējam
        await removeGift(giftLine.key);
        changed = await addGift();
      }

      if (changed) refreshCartUI();
    } catch (e) {
      warn('Reconcile error:', e);
    } finally {
      isProcessing = false;
    }
  }

  function refreshCartUI() {
    log('Refreshing cart UI');
    // Horizon tēma izmanto cart-items-component
    document.querySelectorAll('cart-items-component').forEach(el => {
      if (typeof el.refresh === 'function') el.refresh();
    });
    document.querySelectorAll('cart-drawer-component').forEach(el => {
      if (typeof el.refresh === 'function') el.refresh();
    });
    // Plašāks signāls
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  // ============ Fetch hijack ============

  const cartMutationPaths = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  const originalFetch = window.fetch;

  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input?.url || '');
    const isMutation = cartMutationPaths.some(p => url.includes(p)) && !url.includes('/cart.js');

    const promise = originalFetch.apply(this, arguments);

    if (isMutation) {
      promise.then(() => setTimeout(() => reconcile('fetch'), 250)).catch(() => {});
    }

    return promise;
  };

  // ============ XHR hijack (vecākām integrācijām) ============

  const origOpen = XMLHttpRequest.prototype.open;
  const origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (m, u) {
    this._gwpUrl = u;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    const u = this._gwpUrl || '';
    if (cartMutationPaths.some(p => u.includes(p)) && !u.includes('/cart.js')) {
      this.addEventListener('load', () => setTimeout(() => reconcile('xhr'), 250));
    }
    return origSend.apply(this, arguments);
  };

  // ============ Sākotnējais check + Horizon eventi ============

  function init() {
    reconcile('init');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  ['cart:update', 'cart:refresh'].forEach(evt => {
    document.addEventListener(evt, () => setTimeout(() => reconcile(evt), 100));
  });
})();